import { render } from "./JudgeAttendance.vue?vue&type=template&id=3c8b3c0b"
import script from "./JudgeAttendance.vue?vue&type=script&lang=js"
export * from "./JudgeAttendance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__